import React from 'react';
import { VermerkDto } from '../../../../../api/models/Vermerk/VermerkDto';
import _moment from 'moment';
import {
  IconButton,
  Spinner,
  FlexSpacer,
  Stack
} from '@efast_public/fjd-component-library';
import classes from '../../../Schreibtisch.module.css';
import { useQuery } from '@tanstack/react-query';
import { BehApiRoutes } from '../../../../../api/beh-api';

export interface VermerkVerlaufProps {
  readonly vermerk: VermerkDto;
  readonly caseId: string;
  readonly hasBereitsAbgeschlossen: boolean;
  readonly onEditVermerk: (vermerk: VermerkDto) => void;
  readonly onDeleteVermerk: (vermerk: VermerkDto) => void;
}

const VermerkVerlauf = ({
  vermerk,
  caseId,
  hasBereitsAbgeschlossen,
  onEditVermerk,
  onDeleteVermerk
}: VermerkVerlaufProps) => {
  const vermerkId: string | undefined = vermerk.vermerkId;
  const { data: vermerkVerlaufData } = useQuery<VermerkDto[]>({
    queryKey: [BehApiRoutes.vermerk(caseId, vermerkId ?? '')],
    enabled: !!vermerkId && !hasBereitsAbgeschlossen
  });

  const UpdatedOnTimestamp: string = _moment
    .utc(vermerk.updatedOn)
    .local()
    .format('DD.MM.YYYY [um] HH:mm');
  let updatedTimestampHint: JSX.Element;
  let firstUpdatedVermerkVerlauf: VermerkDto;
  let lastUpdatedVermerkVerlauf: VermerkDto | undefined;
  if (vermerkVerlaufData && vermerkVerlaufData.length > 1) {
    firstUpdatedVermerkVerlauf = vermerkVerlaufData[0];
    lastUpdatedVermerkVerlauf = vermerkVerlaufData.at(-1);
    const vermerkVerlauf =
      firstUpdatedVermerkVerlauf?.bearbeiterDto?.id ===
      lastUpdatedVermerkVerlauf?.bearbeiterDto?.id
        ? `zuletzt bearbeitet am: ${UpdatedOnTimestamp}`
        : `zuletzt bearbeitet am: ${UpdatedOnTimestamp} von ${vermerk.bearbeiterDto?.fullName}`;
    updatedTimestampHint = <div>{vermerkVerlauf}</div>;
  } else {
    updatedTimestampHint = <div>{UpdatedOnTimestamp}</div>;
    firstUpdatedVermerkVerlauf = vermerk;
    lastUpdatedVermerkVerlauf = vermerk;
  }

  if (vermerk.updatedOn !== firstUpdatedVermerkVerlauf?.updatedOn) {
    return <Spinner />;
  }
  return (
    <Stack direction={'column'} spacing="xs">
      <Stack direction={'row'}>
        <div
          id={`bearbeiter_fullname_${vermerk.vermerkId}`}
          style={{ fontWeight: 'bold' }}
        >
          {lastUpdatedVermerkVerlauf?.bearbeiterDto?.fullName}
        </div>
        <FlexSpacer />
        <div>
          <IconButton
            disabled={hasBereitsAbgeschlossen}
            id={`edit_vermerk_${vermerk.vermerkId}`}
            data-testid={`edit_vermerk_${vermerk.vermerkId}`}
            variant="primary-text"
            icon="edit"
            size="sm"
            onClick={() => onEditVermerk(vermerk)}
            label="Vermerk bearbeiten"
          />
          <IconButton
            disabled={hasBereitsAbgeschlossen}
            id={`delete_vermerk_${vermerk.vermerkId}`}
            variant="primary-text"
            icon="trashcan"
            size="sm"
            onClick={() => onDeleteVermerk(vermerk)}
            label="Vermerk endgültig löschen"
          />
        </div>
      </Stack>
      <div
        id={`timestamp-vermerk_${vermerk.vermerkId}`}
        className={classes.vermerkTime}
      >
        {updatedTimestampHint}
      </div>
      <div
        id={`desc-vermerk_${vermerk.vermerkId}`}
        className={classes.vermerkText}
      >
        {vermerk?.description}
      </div>
    </Stack>
  );
};
export default VermerkVerlauf;
